import { useRecordContext } from 'react-admin';
import { GatewayRule } from 'types/embedded/gatewayRule';

import { GatewayRuleFieldGroup } from './GatewayRuleFieldGroup';

type Props = {
  label?: string;
  sortable?: boolean;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function GatewayRuleField(props: Props): JSX.Element {
  const record = useRecordContext<GatewayRule>();
  const conditionGroup = record?.conditionGroup;

  if (
    !conditionGroup ||
    (conditionGroup.expressions?.length <= 0 && conditionGroup.children?.length <= 0)
  ) {
    return <>—</>;
  }

  return (
    <GatewayRuleFieldGroup
      className={`tree ${conditionGroup?.expressions?.length <= 0 ? 'empty-tree' : ''}`}
      group={conditionGroup}
      isOnlyOneExpression={
        conditionGroup?.children?.length <= 0 && conditionGroup?.expressions?.length <= 1
      }
    />
  );
}
